webpackJsonp([12],{

/***/ 2750:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _get_ios_app = __webpack_require__(2751);

var _get_ios_app2 = _interopRequireDefault(_get_ios_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var iosAppDownloadLink = config.IosAppDownloadLink;

    return {
        iosAppDownloadLink: iosAppDownloadLink
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_get_ios_app2.default);

/***/ }),

/***/ 2751:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GetIosApp;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _url = __webpack_require__(793);

var _appStoreButton = __webpack_require__(2752);

var _appStoreButton2 = _interopRequireDefault(_appStoreButton);

var _iphone6Mockup = __webpack_require__(2753);

var _iphone6Mockup2 = _interopRequireDefault(_iphone6Mockup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GetIosApp(_ref) {
    var iosAppDownloadLink = _ref.iosAppDownloadLink;

    return _react2.default.createElement(
        'div',
        { className: 'get-app get-ios-app' },
        _react2.default.createElement(
            'h1',
            { className: 'get-app__header' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'get_app.iosHeader',
                defaultMessage: 'Mattermost works best if you switch to our iPhone app'
            })
        ),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(
            'a',
            {
                className: 'get-ios-app__app-store-link',
                href: (0, _url.useSafeUrl)(iosAppDownloadLink),
                rel: 'noopener noreferrer'
            },
            _react2.default.createElement('img', { src: _appStoreButton2.default })
        ),
        _react2.default.createElement('img', {
            className: 'get-app__screenshot',
            src: _iphone6Mockup2.default
        }),
        _react2.default.createElement(
            'h2',
            { className: 'get-ios-app__already-have-it' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'get_app.alreadyHaveIt',
                defaultMessage: 'Already have it?'
            })
        ),
        _react2.default.createElement(
            'a',
            {
                className: 'btn btn-primary get-ios-app__open-mattermost',
                href: 'mattermost://'
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'get_app.openMattermost',
                defaultMessage: 'Open Mattermost'
            })
        ),
        _react2.default.createElement(
            'span',
            { className: 'get-app__continue-with-browser' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'get_app.continueWithBrowser',
                defaultMessage: 'Or {link}',
                values: {
                    link: _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/switch_team' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'get_app.continueWithBrowserLink',
                            defaultMessage: 'continue with browser'
                        })
                    )
                }
            })
        )
    );
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

GetIosApp.propTypes = {
    iosAppDownloadLink: _propTypes2.default.string
};

/***/ }),

/***/ 2752:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/9a7e4d9e87b489ed28b63bb6c787e93a.png";

/***/ }),

/***/ 2753:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/7d2d2eb3f46c5b58f333d8a3b664fc54.png";

/***/ })

});


// WEBPACK FOOTER //
// 12.ac155e629184aad42bd5.js